export default function setAriaAttribute(element, attr, value) {
    element[value ? "setAttribute" : "removeAttribute"]("aria-" + attr, value);
}
